import { Button, Link, Text, useDisclosure } from '@chakra-ui/react';
import { EXTERNAL_LINK } from '@ui/config/externalLinks';
import { COIN_MODE, useCoinMode } from '@ui/hooks/useCoinMode';
import { useTranslations } from '@ui/i18n';
import { unstakePeriodDict } from '@ui/utils/unstake/periodDict';
import { currentWallet } from '@veno-app/wallet';
import type { ReactNode } from 'react';
import React from 'react';

import UnstakeLearnMoreDrawer from './UnstakeLearnMoreDrawer';

function UnstakeHint() {
  const t = useTranslations();
  const { isOpen: learnMoreIsOpen, onToggle: toggleLearnMore } =
    useDisclosure();
  const globalCoinMode = useCoinMode();
  const coinModeInfo = COIN_MODE[globalCoinMode];
  const periodInfo = unstakePeriodDict[globalCoinMode];
  const isZksync = currentWallet.useIsZksyncChainId();

  const swapLink =
    globalCoinMode === 'atom'
      ? EXTERNAL_LINK.vvsSwapCroToAtom
      : globalCoinMode === 'eth'
      ? EXTERNAL_LINK.syncswapSwapToEth
      : EXTERNAL_LINK.ferroSwapToCro;

  const commonTranslationOptions = {
    SwapLink: () => (
      <Link href={swapLink} isExternal color="pink-500">
        {coinModeInfo.name}
      </Link>
    ),
    LearnMoreLink: (chunks: ReactNode) => (
      <Button variant="link" color="pink.500" onClick={toggleLearnMore}>
        {chunks}
      </Button>
    ),
  };

  return (
    <>
      <UnstakeLearnMoreDrawer open={learnMoreIsOpen} close={toggleLearnMore} />
      <Text textStyle="bodySmall" color="text.light">
        {isZksync
          ? t(
              'unstake-hint-{coin}-{minDays}-{maxDays}-{SwapLink}-{LearnMoreLink}',
              {
                ...commonTranslationOptions,
                coin: coinModeInfo.name,
                minDays: 4,
                maxDays: 10,
              },
            )
          : t(
              'unstake-hint-{coin}-{minDays}-{batchDays}-{maxDays}-{SwapLink}-{LearnMoreLink}',
              {
                ...commonTranslationOptions,
                coin: coinModeInfo.name,
                minDays: periodInfo.unbondingDays,
                batchDays: periodInfo.batchDays,
                maxDays: periodInfo.unbondingDays + periodInfo.batchDays,
              },
            )}
      </Text>
    </>
  );
}

export default UnstakeHint;
